// extracted by mini-css-extract-plugin
export default {"native-button-container":"ButtonGoogle-module__native-button-container__VNHJZ"};